import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './StripeInputWrapper.scss';

const cx = classNames.bind(styles);

export const StripeInputWrapper = ({
  hasFocus,
  hasError,
  isDisabled,
  children,
}) => (
  <div
    className={cx('c-stripe-input-wrapper', {
      'c-stripe-input-wrapper--focus': hasFocus,
      'c-stripe-input-wrapper--error': hasError,
      'c-stripe-input-wrapper--disabled': isDisabled,
    })}>
    {children}
  </div>
);

StripeInputWrapper.propTypes = {
  hasFocus: PropTypes.bool,
  hasError: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.any,
};

StripeInputWrapper.defaultProps = {
  hasFocus: false,
  hasError: false,
  isDisabled: false,
};
